export const GET_RECHARGE_REWARDS = "GET_RECHARGE_REWARDS";
export const EDIT_RECHARGE_REWARD = "EDIT_RECHARGE_REWARD";
export const DELETE_RECHARGE_REWARD = "DELETE_RECHARGE_REWARD";
export const ADD_RECHARGE_REWARD = "ADD_RECHARGE_REWARD";

export const OPEN_RECHARGE_REWARD_DIALOG = "OPEN_RECHARGE_REWARD_DIALOG";
export const CLOSE_RECHARGE_REWARD_DIALOG = "CLOSE_RECHARGE_REWARD_DIALOG";
